document.addEventListener("DOMContentLoaded", function () {
  /**
   * Override Quick Shop để fix preload & init
   */
  theme.initQuickShop = function (scope) {
    scope = scope || document;
    var products = scope.querySelectorAll(".grid-product");

    if (!products.length || !theme.settings || !theme.settings.quickView) return;

    products.forEach((product) => {
      if (product.dataset.quickshopBound === "true") return;

      function productMouseover(evt) {
        var el = evt.currentTarget;
        if (!theme.config.bpSmall) {
          el.removeEventListener("mouseover", productMouseover);
          el.removeEventListener("focusin", productMouseover);

          if (!el || !el.dataset.productId) return;

          var productId = el.dataset.productId;
          var handle = el.dataset.productHandle;
          var btn = el.querySelector(".quick-product__btn");

          try {
            theme.preloadProductModal(handle, productId, btn);
          } catch (err) {
            console.warn("preloadProductModal error:", err);
          }
        }
      }

      product.addEventListener("mouseover", productMouseover);
      product.addEventListener("focusin", productMouseover);
      product.dataset.quickshopBound = "true";
    });
  };

  theme.preloadProductModal = function (handle, productId, btn) {
    try {
      var holder = document.getElementById("QuickShopHolder-" + handle);
      if (!holder) {
        console.warn("QuickShop holder missing for", handle);
        return;
      }

      if (holder.dataset.loaded === "true") {
        if (btn) btn.classList.remove("quick-product__btn--not-ready");
        return;
      }

      var url = (theme.routes?.home || "") + "/products/" + handle + "?view=modal";
      url = url.replace(/\/\/+/g, "/");

      fetch(url, { credentials: "same-origin" })
        .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;

          const div =
            html.querySelector('.product-section[data-product-handle="' + handle + '"]') ||
            html.querySelector('[data-product-handle="' + handle + '"]') ||
            html.querySelector(".product");

          holder.innerHTML = "";
          holder.appendChild(div || html);
          holder.dataset.loaded = "true";

          try {
            new theme.Modals("QuickShopModal-" + productId, "quick-modal-" + productId);
            theme.sections.register("product", theme.Product, holder);
          } catch (e) {
            console.warn("QuickShop init error", e);
          }

          try {
            theme.collapsibles.init(holder);
          } catch (e) {}
          try {
            theme.videoModal();
          } catch (e) {}

          if (btn) btn.classList.remove("quick-product__btn--not-ready");
        })
        .catch((err) => console.error("QuickShop preload failed for", handle, err));
    } catch (err) {
      console.error("Unexpected preload error", err);
    }
  };

  /**
   * Reinit scripts trong scope và append modal shell
   */
  function reinitLoop(scope) {
  scope = scope || document;

  // Reinit scripts gốc (scope-aware)
  if (typeof theme.reinitProductGridItem === "function")
    theme.reinitProductGridItem(scope);
  if (theme.collapsibles && typeof theme.collapsibles.init === "function")
    theme.collapsibles.init(scope);
  if (typeof theme.videoModal === "function") theme.videoModal();
  if (theme.sections && typeof theme.sections.reinit === "function")
    theme.sections.reinit("collection-grid");

  // Quick Shop bind cho scope mới
  if (typeof theme.initQuickShop === "function") theme.initQuickShop(scope);

  // Append modal shell cho sản phẩm mới (với fallback selector)
  scope.querySelectorAll(".grid-product").forEach((card) => {
    const id = card.dataset.productId;
    const handle = card.dataset.productHandle;
    if (!id || !handle) return;

    // tìm section cha hợp lệ để chèn modal
    let sectionEl =
      card.closest("[id^='CollectionSection-']") ||          // legacy section id
      card.closest("[data-section-id]") ||                   // collection page wrapper
      card.closest(".collection-content") ||                 // collection page class
      document.getElementById("CollectionAjaxContent") ||    // specific wrapper in your main-collection.liquid
      card.closest(".page-width") ||                         // fallback common container
      document.body;                                        // cuối cùng fallback chung

    // nếu modal đã tồn tại thì bỏ qua
    if (document.getElementById("QuickShopModal-" + id)) return;

    // nếu sectionEl tồn tại thì append, nếu không thì append vào body
    const modalHTML = `
      <div id="QuickShopModal-${id}" class="modal modal--square modal--quick-shop" data-product-id="${id}">
        <div class="modal__inner">
          <div class="modal__centered">
            <div class="modal__centered-content">
              <div id="QuickShopHolder-${handle}"></div>
            </div>
            <button type="button" class="modal__close js-modal-close text-link">
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>
              <span class="icon__fallback-text">"Close (esc)"</span>
            </button>
          </div>
        </div>
      </div>`;

    try {
      // nếu sectionEl là element block (ví dụ .collection-content), chèn sau nó
      if (sectionEl && sectionEl.insertAdjacentHTML) {
        sectionEl.insertAdjacentHTML("afterend", modalHTML);
      } else {
        document.body.insertAdjacentHTML("beforeend", modalHTML);
      }
    } catch (err) {
      // fallback an toàn
      document.body.insertAdjacentHTML("beforeend", modalHTML);
      console.warn("QuickShop append fallback used for product", id, err);
    }

    // LƯU Ý: không gọi preload hàng loạt ở đây — preload on hover sẽ do theme.initQuickShop(scope) lo
  });
}


  document.querySelectorAll("[id^='featured-collection-Pagination-']").forEach(function (
    paginationEl
  ) {
    const sectionId = paginationEl.id.replace("featured-collection-Pagination-", "");
    const containerSelector = "#featured-collection-Loop-" + sectionId;
    const paginationSelector = "#featured-collection-Pagination-" + sectionId;
    let currentPage = 1;

    const showLessBtn = paginationEl.querySelector(".show-less");
    if (showLessBtn) showLessBtn.style.display = "none";

    function initAjaxinate() {
      return new Ajaxinate({
        container: containerSelector,
        pagination: paginationSelector,
        method: "click",
        loadingText: "Loading...",
      });
    }

    let endlessScroll = initAjaxinate();

    document.addEventListener("ajaxinate:loaded", function (e) {
      if (!paginationEl.contains(e.target)) return;

      currentPage++;
      const btn = paginationEl.querySelector(".show-less");
      if (btn) btn.style.display = "inline-block";

      const container = document.querySelector(containerSelector);
      reinitLoop(container);
    });

    paginationEl.addEventListener("click", function (e) {
      if (!e.target.matches(".show-less")) return;
      e.preventDefault();

      const container = document.querySelector(containerSelector);
      const sectionWrapper = container.closest("[id^='CollectionSection-']") || container;
      const sectionTop = sectionWrapper.getBoundingClientRect().top + window.scrollY;

      const firstPageUrl = window.location.pathname + "?page=1&section_id=" + sectionId;

      fetch(firstPageUrl)
        .then((res) => res.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");

          container.innerHTML = doc.querySelector(containerSelector).innerHTML;
          paginationEl.innerHTML = doc.querySelector(paginationSelector).innerHTML;

          currentPage = 1;

          const newShowLess = paginationEl.querySelector(".show-less");
          if (newShowLess) newShowLess.style.display = "none";

          reinitLoop(container);
          endlessScroll = initAjaxinate();

          window.scrollTo({
            top: sectionTop,
            behavior: "smooth",
          });
        });
    });
  });

  document.querySelectorAll('[id^="featured-collection-Loop-"]').forEach(function (loop) {
    const mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.addedNodes && m.addedNodes.length) reinitLoop(loop);
      });
    });
    mo.observe(loop, { childList: true });
  });

  reinitLoop(document);
});
